import React, { Component, useRef } from "react";
import Slider from "react-slick";
import { BenifitItem } from "../soundboxwork";
import instant from "../../assets/svgs/upi/identifi.svg";
import languge from "../../assets/svgs/upi/enhance.svg";
import accept from "../../assets/svgs/upi/enhance.svg";
import { useTranslation } from "react-i18next";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useWindowSize } from "@uidotdev/usehooks";
import support from "../../assets/svgs/soundbox/support.svg";

import PropTypes from "prop-types";

export const SliderdotUpiqr = () => {
  const sliderRef = useRef(null);
  const { width } = useWindowSize();
  let isswipe;
  let show;
  let isInfinite;

  if (width > 1023) {
    isswipe = 3;
    show = false;
  } else if (width < 1024 && width > 871) {
    isswipe = 2;
    show = true;
  } else {
    isswipe = 1;
    show = true;
  }

  const { t } = useTranslation();
  const settings = {
    dots: true,
    arrows: false, // Ẩn các mũi tên điều hướng
    infinite: true,
    speed: 500,
    slidesToShow: isswipe,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
  };
  const totalSlides = 6;
  return (
    <div className="pb-[54px] pt-[20px]">
      <div className="slider-container ml-[30px] sm:ml-0">
        <Slider ref={sliderRef} {...settings}>
          <BenifitItem
            image={instant}
            titleheader={t("upiqrcode.identi")}
            title={t("upiqrcode.indentides")}
          />
          <BenifitItem
            image={languge}
            titleheader={t("upiqrcode.reduced")}
            title={t("upiqrcode.reduceddes")}
          />
          <BenifitItem
            image={accept}
            titleheader={t("upiqrcode.enhancel")}
            title={t("upiqrcode.enhanceldes")}
          />

          <BenifitItem
            image={support}
            titleheader={t("upiqrcode.fater")}
            title={t("upiqrcode.faterdes")}
          />
          <BenifitItem
            image={support}
            titleheader={t("upiqrcode.ease")}
            title={t("upiqrcode.easedes")}
          />
        </Slider>
      </div>
    </div>
  );
};
